export enum CssFile {
	web_app,
	assessment,
}
